import { ChangeDetectionStrategy, Component, inject, Input, OnInit, signal } from '@angular/core';
import { ICustomer } from '../../core/interfaces/ICustomer';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { CustomersService } from '../../core/services/CustomersService';
import { NotificationService } from '../../../../core/services/NotificationService';
import { finalize } from 'rxjs';
import { ApiErrorResponse } from '../../../../core/classes/ApiErrorResponse';
import { ILog } from '../../core/interfaces/ILog';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';
import { LocaleDateFormatPipe } from '../../../../shared/pipes/locale-date-format.pipe';
import { TimeFormatPipe } from '../../../../shared/pipes/time-format.pipe';
import { EmptyPipe } from '../../../../shared/pipes/empty.pipe';
import { BaseComponent } from '../../../../core/layout/components/abstracts/base.component';

@Component({
  selector: 'app-logs-table',
  standalone: true,
  imports: [
    TranslatePipe,
    LoaderComponent,
    LocaleDateFormatPipe,
    TimeFormatPipe,
    EmptyPipe
  ],
  templateUrl: './logs-table.component.html',
  styleUrl: './logs-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogsTableComponent extends BaseComponent implements OnInit {

  @Input({ required: true }) customer: ICustomer;

  public isLoading = signal(true);
  public data: ILog[] = [];

  private readonly _customersService = inject(CustomersService);
  private readonly _notificationService = inject(NotificationService);

  public ngOnInit(): void {
    this._customersService.getCustomerLogs(this.customer)
      .pipe(
        finalize(() => this.isLoading.set(false))
      )
      .subscribe({
        next: (data) => this.data = data.data,
        error: ({ error }: ApiErrorResponse) => {
          this._notificationService.pushError(
            'Fehler'.trans('notifications/error.Title'),
            error.message.trans(`get-customer-logs/notifications/${error.message}.Message`)
          );
        }
      });
  }
}
